export const authEmailSelector = (state) => state?.auth?.email ?? null;
export const authUserIdSelector = (state) => state?.auth?.user_id ?? null;
export const authIsLoadingSelector = (state) => state?.auth?.isLoading;
export const authCurrencySelector = (state) => state?.auth?.currency;
export const authAvatarUrlSelector = (state) => state?.auth?.avatarUrl ?? null;
export const authAccountTypeSelector = (state) => state?.auth?.account_type ?? null;
export const authUserData = (state) => {
    return {
        userId: state?.auth?.user_id ?? null,
        email: state?.auth?.email ?? null,
        isLoading: state?.auth?.isLoading ?? null,
        currency: state?.auth?.currency ?? null,
        avatarUrl: state?.auth?.avatarUrl ?? null,
        accountType: state?.auth?.account_type ?? null,
    }
};

